// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hCkjH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initBigCatsReveal", ()=>initBigCatsReveal);
var _gsap = require("gsap");
var _scrollTrigger = require("gsap/dist/ScrollTrigger");
(0, _gsap.gsap).registerPlugin((0, _scrollTrigger.ScrollTrigger));
/**
 * Big Cats Image Reveal Animation
 * 
 * Wraps each image in a container with overflow hidden,
 * then reveals the image by animating a vertical mask using clip-path.
 * The animation triggers when scrolling into view with a stagger effect.
 */ // Get scroller element for ScrollTrigger
const getScroller = ()=>{
    // Check if smooth scroll is actually active (not just if the instance exists)
    return window.smoothScroll && window.smoothScroll.isRunning ? '#content' : window;
};
function initBigCatsReveal() {
    const images = document.querySelectorAll('.big-cats-grid .big-cat-image');
    if (!images.length) {
        console.warn('No big cat images found');
        return;
    }
    // Wrap each image in a reveal container
    images.forEach((img)=>{
        // Create wrapper for overflow/mask control
        const wrapper = document.createElement('div');
        wrapper.className = 'big-cat-reveal-wrapper';
        // Insert wrapper before image and move image inside
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
        // Initial states: hide via vertical clip-path and slight scale
        (0, _gsap.gsap).set(wrapper, {
            autoAlpha: 1
        });
        (0, _gsap.gsap).set(img, {
            clipPath: 'inset(100% 0% 0% 0%)',
            // webkitClipPath for Safari fallback
            webkitClipPath: 'inset(100% 0% 0% 0%)',
            scale: 1.12
        });
    });
    // Build separate scrubbed timelines for each row
    const imagesArray = Array.from(document.querySelectorAll('.big-cats-grid .big-cat-image'));
    // Detect if we're in mobile layout (768px and below)
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    let firstRow, secondRow, thirdRow, fourthRow;
    if (isMobile) {
        // Mobile: 2 images per row, 4 rows total
        firstRow = imagesArray.slice(0, 2); // images 1-2
        secondRow = imagesArray.slice(2, 4); // images 3-4
        thirdRow = imagesArray.slice(4, 6); // images 5-6
        fourthRow = imagesArray.slice(6, 8); // images 7-8
    } else {
        // Desktop: 4 images per row, 2 rows total
        firstRow = imagesArray.slice(0, 4); // images 1-4
        secondRow = imagesArray.slice(4, 8); // images 5-8
    }
    // First row timeline
    const tl1 = (0, _gsap.gsap).timeline({
        defaults: {
            ease: 'power3.out'
        },
        scrollTrigger: {
            trigger: '.big-cats-grid',
            scroller: getScroller(),
            start: isMobile ? 'top 85%' : 'top 75%',
            end: isMobile ? 'top 35%' : 'top 15%',
            scrub: 1,
            invalidateOnRefresh: true
        }
    });
    tl1.to(firstRow, {
        clipPath: 'inset(0% 0% 0% 0%)',
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        duration: 1,
        stagger: {
            each: 0.08,
            from: 'start'
        }
    }, 0);
    tl1.to(firstRow, {
        scale: 1,
        duration: 1.1,
        ease: 'power2.out',
        stagger: {
            each: 0.08,
            from: 'start'
        }
    }, 0);
    // Second row timeline
    const tl2 = (0, _gsap.gsap).timeline({
        defaults: {
            ease: 'power3.out'
        },
        scrollTrigger: {
            trigger: '.big-cats-grid',
            scroller: getScroller(),
            start: isMobile ? 'top 65%' : 'top 45%',
            end: isMobile ? 'top 45%' : 'top -25%',
            scrub: 0.8,
            invalidateOnRefresh: true
        }
    });
    tl2.to(secondRow, {
        clipPath: 'inset(0% 0% 0% 0%)',
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        duration: 1,
        stagger: {
            each: 0.08,
            from: 'start'
        }
    }, 0);
    tl2.to(secondRow, {
        scale: 1,
        duration: 1.1,
        ease: 'power2.out',
        stagger: {
            each: 0.08,
            from: 'start'
        }
    }, 0);
    // Mobile only: Third and fourth row timelines
    if (isMobile) {
        const tl3 = (0, _gsap.gsap).timeline({
            defaults: {
                ease: 'power3.out'
            },
            scrollTrigger: {
                trigger: '.big-cats-grid',
                scroller: getScroller(),
                start: 'top 45%',
                end: 'top 25%',
                scrub: 0.8,
                invalidateOnRefresh: true
            }
        });
        tl3.to(thirdRow, {
            clipPath: 'inset(0% 0% 0% 0%)',
            webkitClipPath: 'inset(0% 0% 0% 0%)',
            duration: 1,
            stagger: {
                each: 0.08,
                from: 'start'
            }
        }, 0);
        tl3.to(thirdRow, {
            scale: 1,
            duration: 1.1,
            ease: 'power2.out',
            stagger: {
                each: 0.08,
                from: 'start'
            }
        }, 0);
        const tl4 = (0, _gsap.gsap).timeline({
            defaults: {
                ease: 'power3.out'
            },
            scrollTrigger: {
                trigger: '.big-cats-grid',
                scroller: getScroller(),
                start: 'top 25%',
                end: 'top 5%',
                scrub: 0.8,
                invalidateOnRefresh: true
            }
        });
        tl4.to(fourthRow, {
            clipPath: 'inset(0% 0% 0% 0%)',
            webkitClipPath: 'inset(0% 0% 0% 0%)',
            duration: 1,
            stagger: {
                each: 0.08,
                from: 'start'
            }
        }, 0);
        tl4.to(fourthRow, {
            scale: 1,
            duration: 1.1,
            ease: 'power2.out',
            stagger: {
                each: 0.08,
                from: 'start'
            }
        }, 0);
    }
    // Ensure ScrollTrigger calculates after DOM mutations
    (0, _scrollTrigger.ScrollTrigger).refresh();
}
// Wait for DOM and smooth scroll to be ready
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ()=>{
    // Small delay to ensure smooth scroll is initialized
    setTimeout(initBigCatsReveal, 100);
});
else setTimeout(initBigCatsReveal, 100);

},{"gsap":"kKW9v","gsap/dist/ScrollTrigger":"jusUN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["hCkjH"], "hCkjH", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.5e9b5fbe.js.map
